import * as TYPES from './_store/types';

export function asyncData(store) {
    return Promise.all([
        !this.noAgent && (this.agentId || this.agentId === 0) && this.getAgentInfo(this.agentId),
        store[TYPES.GET_FORMREQUIRED]()
    ]);
}